<template>
    <div>
        <!-- 第一行 -->
        <el-form
            inline 
            :model="form" 
            :rules="rules"
            ref="rule1"
            label-width="135px"
            size="mini">
            <!-- 收货人姓名 -->
            <el-form-item
                :label="$t('message.caddress.form1')"
                prop="consignee">
                <el-input
                    v-model="form.consignee"
                    class="center-address-form-input">
                </el-input>
            </el-form-item>
            <!-- 收货地址 -->
            <el-form-item
                :label="$t('message.caddress.form2')"
                prop="address">
                <el-input
                    v-model="form.address"
                    type="textarea"
                    :autosize='{minRows:1,maxRows:2}'
                    class="center-address-form-input">
                </el-input>
            </el-form-item>
        </el-form>
        <!-- 第二行 -->
        <el-form
            inline 
            :model="form" 
            :rules="rules"
            ref="rule2"
            label-width="135px"
            size="mini">
            <!-- 联系电话 -->
            <el-form-item
                :label="$t('message.caddress.form3')"
                prop="mobile">
                <el-input
                    v-model="form.mobile"
                    class="center-address-form-input">
                </el-input>
            </el-form-item>
            <!-- 电子邮箱 -->
            <el-form-item
                :label="$t('message.caddress.form4')"
                prop="email">
                <el-popover
                    placement="right-start"
                    trigger="focus">
                    <ul class="center-address-email-tips">
                        <li>{{$t("public.emailTips")}}</li>
                    </ul>
                    <el-input 
                        type="textarea"
                        v-model="form.email"
                        slot="reference"
                        autosize
                        class="center-address-form-input">
                    </el-input>
                </el-popover>
            </el-form-item>
        </el-form>
        <!-- 第三行 -->
        <el-form
            inline 
            :model="form" 
            label-width="135px"
            size="mini">
            <!-- 传真 -->
            <el-form-item
                :label="$t('message.caddress.form5')"
                prop="fax">
                <el-input
                    v-model="form.fax"
                    class="center-address-form-input">
                </el-input>
            </el-form-item>
        </el-form>
        <!-- 第四行 -->
        <el-form
            :model="form" 
            label-width="135px"
            size="mini">
            <!-- 是否默认地址 -->
            <el-form-item>
                <el-checkbox
                    v-model="form.is_default">
                    {{$t("message.caddress.form6")}}
                </el-checkbox>
            </el-form-item>
        </el-form>
        <!-- 提交按钮插槽 -->
        <el-form
            label-width="135px"
            size="mini">
            <el-form-item>
                <slot name="submit"
                    :form="form"
                    :rule="$refs">
                </slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { email } from "@/utils/validate";

export default {
    data() {
        let validateEmail = (rule, value, callback) => {
            email(this, false, value, callback);
        }
        return {
            form: {
                consignee: "",
                address: "",
                mobile: "",
                email: "",
                fax: "",
                is_default: false
            },
            rules: {
                consignee: [
                    { required: true, message: this.$t("message.caddress.rule1"), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t("message.caddress.rule2"), trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: this.$t("message.caddress.rule3"), trigger: 'blur' }
                ],
                email: [
                    { required: false, validator: validateEmail, trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        addressDetail: {
            type: Object,
            default: () => { return {} }
        }
    },
    watch: {
        addressDetail: {
            handler: function(value) {
                let {
                    consignee = '',
                    address = '',
                    mobile = '',
                    email = '',
                    fax = '',
                    status = true 
                } = value;
                this.form = {
                    consignee,
                    address,
                    mobile,
                    email,
                    fax,
                    is_default: !status
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
.center-address-form-input{
    width: 178px;
}
.center-address-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
